// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-frame[data-v-765b7c9f] {\n  width: 420px;\n}\n.el-dialog__header[data-v-765b7c9f] {\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n}", ""]);
// Exports
module.exports = exports;
